// extracted by mini-css-extract-plugin
export var orderSummary = "_r9-0";
export var showMoreLessButton = "_r9-1";